module.exports = {
  "/": {},
  "/owner/:ownerId": {
    "success": {
      "rep view data loaded": [
        "DETAIL_INDEX_LOAD",
        "OVERVIEW_TABLE_LOADED",
        "DEAL_TABLE_LOADED"
      ],
      "empty state": [
        "DETAIL_INDEX_LOAD",
        "OVERVIEW_TABLE_EMPTY_STATE",
        "DEAL_TABLE_LOADED"
      ]
    },
    "error": [
      "DETAIL_INDEX_OVERVIEW_LOAD_FAIL",
      "DEAL_TABLE_LOAD_FAIL"
    ]
  },
  "/teams": {
    "success": {
      "overview data loaded": [
        "OVERVIEW_INDEX_LOAD",
        "OVERVIEW_TABLE_LOADED"
      ],
      "empty state": [
        "OVERVIEW_TABLE_EMPTY_STATE"
      ]
    },
    "error": [
      "OVERVIEW_INDEX_FAILED"
    ]
  },
  "/teams/:teamId": {
    "success": {
      "team index with team selected loaded": [
        "OVERVIEW_INDEX_LOAD",
        "OVERVIEW_TABLE_LOADED"
      ],
      "empty state": [
        "OVERVIEW_TABLE_EMPTY_STATE"
      ]
    },
    "error": [
      "OVERVIEW_INDEX_FAILED"
    ]
  },
  "/analyze": {
    "success": {
      "analyze loaded": [
        "ANALYZE_LOAD"
      ]
    },
    "error": [
      "ANALYZE_FAIL"
    ]
  }
};